export interface LegalLink {
  readonly labelKey: string;
  readonly url: string;
}

// Externe Rechtstext-Links (Impressum/AGB/Datenschutz). Geteilte Single Source of
// Truth für den Footer (pages-frontend/footer) UND das mobile Header-Burger-Menü
// (pages-frontend/navigation-menu), damit beide nicht auseinanderlaufen.
// Labels werden über die i18n-Keys via translate aufgelöst (reagieren auf Sprachwechsel).
export const LEGAL_LINKS: readonly LegalLink[] = [
  { labelKey: 'redesign.footer.IMPRINT',          url: 'https://www.mit-esolutions.at/impressum/' },
  { labelKey: 'redesign.footer.TERMS_CONDITIONS', url: 'https://www.mit-esolutions.at/agb/' },
  { labelKey: 'redesign.footer.PRIVACY',          url: 'https://www.mit-esolutions.at/datenschutzerklaerung/' },
];
